// index.jsx o main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { AuthProvider } from './functions/AuthContext';
import { ToastProvider } from './components/ToastProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/tailwind.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


ReactDOM.createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <ToastProvider>
      <BrowserRouter basename="/">
        <AppRoutes />
      </BrowserRouter>
    </ToastProvider>
  </AuthProvider>
);
